import EscalatedComplaints from "../../../jsx/components/Dashboard/EscalatedComplaints/escalatedcomplaints";

const EscalatedComplaintsWrapper = () => {
  return <EscalatedComplaints />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.grievance_staff, _enum.ROUTE_PERSONAS.nodal_officer];
export default constore(EscalatedComplaintsWrapper);
